import React from "react";
import { ALink } from "../../components/atoms/StyledLink";
import { Link } from "gatsby";

export const impact = null;
export const others = null;
